import React, { useEffect, useState } from 'react'
import { CNav, CNavItem, CNavLink, CTabContent, CTabPane, CButton, CCard, CCardBody, CFormSelect, CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CFormLabel, CSpinner } from '@coreui/react'
import SaveExtra from '../../services/general/saveExtraData.api'
import PatientNoteDataCRUD from '../../services/general/patientNoteData.api'
import ModifyPatientMap from '../../services/general/modifyPatientMap.api'
import PatientNoteVIew from '../../components/shared/PatientNoteVIew'
import PatientLabsCRUD from '../../services/general/patientLabsCrud.api'
import PatientSuperBillData from '../../services/general/patientSuperBill.api'
import { CalendarDays, Files } from 'lucide-react'
import PatientOrdersCRUD from '../../services/general/patientOrders.api'
import Accordions from '../../components/shared/Accordians'
import Carder from '../../components/shared/Carder'
import PatientInfo from './PatientInfo'
import { getAllAppointments, getAllAppointmentsDetails } from '../../components/shared/appointmentFilterData'
import PatientInfoSecond from './PatientinfoSecond'
import PatientInfoFreeType from './PatientInfoFreetype'

const safeJsonParse = (value, fallback = null) => {
  if (!value) return fallback
  if (typeof value !== 'string') return value

  try {
    return JSON.parse(value)
  } catch (error) {
    return fallback
  }
}

const getScriptFiles = (script) => (Array.isArray(script) ? script : script ? [script] : [])

const getOrderFreeTypeSummary = (patient, diagnosis) => {
  const noteData = safeJsonParse(patient?.NoteDetails?.data, {})
  const summary = noteData?.freeTypesEverything?.OrderFreeType?.[diagnosis]
  return typeof summary === 'string' ? summary.trim() : ''
}

const TabLoader = () => (
  <div className="d-flex align-items-center justify-content-center" style={{ height: '45vh' }}>
    <CSpinner color="primary" />
  </div>
)

const PatientAllDetails = ({ viewPatientDetail, selectedDetails, showNotePatient, setShowNotePatient }) => {
  const [activeKey, setActiveKey] = useState(0)
  const [insurance, setInsurance] = useState(null)
  const [appointments, setAppointments] = useState([])
  const [patientTreatments, setPatientTreatments] = useState([])
  const [diagnosisData, setDiagnosisData] = useState([])
  const [patientDiagnosis, setPatientDiagnosis] = useState([])
  const [allLabs, setAllLabs] = useState([])
  const [superBill, setSuperBill] = useState([])
  const [orderActiveKey, setOrderActiveKey] = useState(1)
  const [showOrderPopUp, setShowOrderPopUp] = useState(false)
  const [file, setFile] = useState([])
  const [selectedNote, setSelectedNote] = useState(null)

  const [ordersData, setOrdersData] = useState([])
  const [tabLoading, setTabLoading] = useState({
    0: true,
    1: true,
    2: true,
    3: true,
    4: true,
  })
  const [tabLoaded, setTabLoaded] = useState({
    0: false,
    1: false,
    2: false,
    3: false,
    4: false,
  })

  const markTabLoaded = (tabKey) => {
    setTabLoading((prev) => ({
      ...prev,
      [tabKey]: false,
    }))
    setTabLoaded((prev) => ({
      ...prev,
      [tabKey]: true,
    }))
  }

  const fetchOrdersPatient = async () => {
    try {
      let formattedData
      formattedData = await PatientOrdersCRUD('Get', '', viewPatientDetail.PatientID, '', '', '', '')

      formattedData = safeJsonParse(formattedData.d, {})
      formattedData = formattedData?.Data || []

      if (formattedData) {
        formattedData = formattedData.map((item, idx) => {
          return {
            ...item,
            medication: item.medication === '' ? {} : safeJsonParse(item.medication, {}),
            // imaging: item.imaging.length > 0 ? JSON.parse(item?.imaging) : {},
            // medication: item.medication ? JSON.parse(item.medication) : {},
            // labs: item.labs.length > 0 ? JSON.parse(item?.labs) : {}
          }
        })
      }

      setOrdersData(formattedData)
    } catch (error) {
      console.log('error in order data', error)
      setOrdersData([])
    } finally {
      markTabLoaded(4)
    }
  }

  const handleScript = (file) => {
    setFile(file)
    setShowOrderPopUp(true)
  }

  const getSuperBillData = async () => {
    try {
      let data = await PatientSuperBillData('Get_By_PatientId', '', '', '', viewPatientDetail.PatientID.toString())
      data = safeJsonParse(data?.d, {})?.Data || []

      if (data) {
        data = data?.map((item) => {
          return {
            Id: item.Id,
            Data: safeJsonParse(item?.JsonData, {}),
          }
        })
      }

      setSuperBill(data)
    } catch (error) {
      console.log('Error in getSuperBillData', error)
      setSuperBill([])
    } finally {
      markTabLoaded(3)
    }
  }

  const getAppointmentData = async () => {
    try {
      const structureData = await getAllAppointments('GET')
      let filterPatient = structureData.filter((item) => item.patientID === viewPatientDetail.PatientID)

      let flatAppointments = filterPatient.flatMap((p) => p.appointmentDetails)

      setAppointments(flatAppointments || [])
    } catch (error) {
      console.log('Error in getAppointmentData', error)
      setAppointments([])
    } finally {
      markTabLoaded(1)
    }
  }

  const getInsurance = () => {
    try {
      if (selectedDetails && selectedDetails?.Insurances?.length > 0) {
        let insuranceData = selectedDetails?.Insurances.map((item) => {
          return {
            ...item,
            InsuranceDetails: safeJsonParse(item.InsuranceDetails, []),
          }
        })

        setInsurance(insuranceData.length > 0 && insuranceData[0]?.InsuranceDetails[0])
      } else {
        setInsurance(null)
      }
    } finally {
      markTabLoaded(0)
    }
  }

  const sortNotesLatestFirst = (notes = []) => {
    return [...notes].sort((a, b) => {
      const aDate = new Date(a.date || a.data?.date || a.data?.CreatedDate || a.data?.createdDate || 0)
      const bDate = new Date(b.date || b.data?.date || b.data?.CreatedDate || b.data?.createdDate || 0)
      return bDate - aDate
    })
  }

  const GetPatientTreatmentsNotes = async () => {
    try {
      let data
      data = await PatientNoteDataCRUD('GET', viewPatientDetail.PatientID)

      if (data) {
        data = safeJsonParse(data.d, {})?.Data
        data = data?.map((item) => {
          return {
            ...item,
            data: safeJsonParse(item?.data, {}),
          }
        })

        data = sortNotesLatestFirst(data)

        console.log("patientData from patientalldetails", data)

        setPatientTreatments(data || [])
      }
    } catch (error) {
      // toast.error('error in patient treatment', toastConfig)
      console.error('Error fetching patient orders', error)
      setPatientTreatments([])
    } finally {
      markTabLoaded(2)
    }
  }

  const getPatientDiagnosis = async () => {
    let diagnosisData = await ModifyPatientMap('GETALL', viewPatientDetail.PatientID, '')
    let tempData = safeJsonParse(diagnosisData.d, {})?.Data || []

    diagnosisData = tempData.filter((obj) => {
      if (viewPatientDetail.PatientID == obj.PatientID) {
        return obj
      }
    })
    let patientD = []
    try {
      patientD = diagnosisData[0]?.Diagnosis?.split(',')
    } catch (e) {}

    setPatientDiagnosis(patientD)

    setDiagnosisData(diagnosisData)
  }

  const fetchPatientLabs = async () => {
    try {
      let formattedData
      formattedData = await PatientLabsCRUD('GET', viewPatientDetail.PatientID.toString())
      formattedData = safeJsonParse(formattedData.d, {})
      formattedData = formattedData?.Data || []
      if (formattedData) {
        formattedData = formattedData?.map((item) => {
          return {
            ...item,
            data: safeJsonParse(item.data, {}),
          }
        })
      }
      setAllLabs(formattedData)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (!viewPatientDetail?.PatientID) return

    setActiveKey(0)
    setInsurance(null)
    setAppointments([])
    setPatientTreatments([])
    setDiagnosisData([])
    setPatientDiagnosis([])
    setAllLabs([])
    setSuperBill([])
    setOrdersData([])
    setSelectedNote(null)
    setTabLoading({
      0: true,
      1: true,
      2: true,
      3: true,
      4: true,
    })
    setTabLoaded({
      0: false,
      1: false,
      2: false,
      3: false,
      4: false,
    })
  }, [viewPatientDetail?.PatientID])

  useEffect(() => {
    if (!viewPatientDetail?.PatientID || tabLoaded[activeKey]) return

    if (activeKey === 0) {
      getInsurance()
      return
    }

    if (activeKey === 1) {
      getAppointmentData()
      return
    }

    if (activeKey === 2) {
      GetPatientTreatmentsNotes()
      getPatientDiagnosis()
      fetchPatientLabs()
      return
    }

    if (activeKey === 3) {
      getSuperBillData()
      return
    }

    if (activeKey === 4) {
      fetchOrdersPatient()
    }
  }, [activeKey, tabLoaded, viewPatientDetail?.PatientID])

  const formatDate = (dateString) => {
    if (!dateString) return '' // Handle undefined/null cases
    const [day, month, year] = dateString.split('-')
    return `${month}-${day}-${year}`
  }

  const handleNoteRedirect = (note, index) => {
    setSelectedNote({ note, index })
    setShowNotePatient(true)
  }

  const tabs = ['Patient Details', 'Appointments', 'Note', 'Super Bill', 'Orders']
  const patientAllDetailsActivePillColor = '#1976D2'

  if (!viewPatientDetail?.PatientID) {
    return <div className="text-center text-secondary py-4">Patient details are not available.</div>
  }

  return (
    <>
      {
        <div className="d-flex" style={{ height: '70vh', background: '#f8f9fa' }}>
          <div className="p-3 border-end bg-white shadow-sm" style={{ minWidth: '220px' }}>
            <CNav variant="pills" className="flex-column gap-2">
              {tabs.map((tab, index) => (
                <CNavItem key={index}>
                  <CNavLink
                    active={activeKey === index}
                    onClick={() => setActiveKey(index)}
                    className={`d-flex align-items-center justify-content-start px-3 py-2 fw-semibold rounded-pill ${activeKey === index ? 'text-white' : 'text-dark'}`}
                    style={{
                      cursor: 'pointer',
                      transition: 'all 0.2s ease-in-out',
                      backgroundColor: activeKey === index ? patientAllDetailsActivePillColor : undefined,
                    }}
                  >
                    {tab}
                  </CNavLink>
                </CNavItem>
              ))}
            </CNav>
          </div>

          <div className="flex-fill p-4" style={{ overflow: 'auto' }}>
            <CTabContent>
              <CTabPane visible={activeKey === 0}>
                <div className=" ">
                  <div className="mb-3">
                    <h5>Patient Details</h5>
                  </div>

                  <CCard>
                    <CCardBody style={{ height: '60vh', overflow: 'auto' }}>
                      {tabLoading[0] ? (
                        <TabLoader />
                      ) : (
                        <>
                          <h6 className="mb-3">Basic Information</h6>
                          <table className="table table-borderless">
                            <tbody>
                              <tr>
                                <th className="text-start" style={{ width: '200px' }}>
                                  First Name
                                </th>
                                <td>{viewPatientDetail.FirstName}</td>
                              </tr>
                              <tr>
                                <th className="text-start">Middle Name</th>
                                <td>{viewPatientDetail?.MiddleName || '-'}</td>
                              </tr>
                              <tr>
                                <th className="text-start">Last Name</th>
                                <td>{viewPatientDetail?.LastName || '-'}</td>
                              </tr>
                              <tr>
                                <th className="text-start">Date of Birth</th>
                                <td>{viewPatientDetail.DOB}</td>
                              </tr>
                              <tr>
                                <th className="text-start">Gender</th>
                                <td>{viewPatientDetail.Gender}</td>
                              </tr>
                              <tr>
                                <th className="text-start">Age</th>
                                <td>{viewPatientDetail.Age}</td>
                              </tr>
                              <tr>
                                <th className="text-start">Emergency Contact Name</th>
                                <td>{viewPatientDetail.EmergencyName}</td>
                              </tr>
                              <tr>
                                <th className="text-start">Emergency Contact Phone</th>
                                <td>{viewPatientDetail.EmergencyPhone}</td>
                              </tr>
                              <tr>
                                <th className="text-start">Status</th>
                                <td>{viewPatientDetail.Status === 'NewPatient' ? 'New Patient' : viewPatientDetail.Status}</td>
                              </tr>
                            </tbody>
                          </table>

                          <h6 className="mt-4 mb-3">Facility Details</h6>
                          <table className="table table-borderless">
                            <tbody>
                              <tr>
                                <th className="text-start" style={{ width: '200px' }}>
                                  Facility
                                </th>
                                <td>{viewPatientDetail.FacilityName || '-'}</td>
                              </tr>
                              <tr>
                                <th className="text-start">Room Number</th>
                                <td>{viewPatientDetail.Room || '-'}</td>
                              </tr>
                              <tr>
                                <th className="text-start">Diagnosis</th>
                                <td>{viewPatientDetail.Diagnosis || '-'}</td>
                              </tr>
                            </tbody>
                          </table>

                          <h6 className="mt-4 mb-3">Insurance Information</h6>
                          <table className="table table-borderless">
                            <tbody>
                              <tr>
                                <th className="text-start" style={{ width: '200px' }}>
                                  Primary Insurance
                                </th>
                                <td>{insurance?.Type || '-'}</td>
                              </tr>
                              <tr>
                                <th className="text-start">Secondary Insurance</th>
                                <td>{insurance?.SubType || '-'}</td>
                              </tr>
                              <tr>
                                <th className="text-start">Policy Number</th>
                                <td>{insurance?.PolicyNumber || '-'}</td>
                              </tr>
                              <tr>
                                <th className="text-start">Credentialed</th>
                                <td>{insurance?.Credentialed || '-'}</td>
                              </tr>
                            </tbody>
                          </table>
                        </>
                      )}
                    </CCardBody>
                  </CCard>
                </div>
              </CTabPane>

              <CTabPane visible={activeKey === 1}>
                <div style={{ height: '60vh', width: '', overflow: 'auto' }}>
                  <h5 className="mb-3">Appointments</h5>

                  {tabLoading[1] ? (
                    <TabLoader />
                  ) : (
                    <table className="table table-striped table-bordered">
                      <thead className="table-light">
                        <tr>
                          <th>Provider Name</th>
                          <th>Schedule Date</th>
                          <th>End Date</th>
                          <th>Status</th>
                          <th>Visit</th>
                        </tr>
                      </thead>
                      <tbody>
                        {appointments?.length > 0 ? (
                          appointments?.map((appointment, index) => (
                            <tr key={index}>
                              <td>{appointment.data.ProviderName}</td>
                              <td>{appointment.data.StartTime}</td>
                              <td>{appointment.data.EndTimezone || '-'}</td>
                              <td>{appointment.data.Status}</td>
                              {appointment?.data?.patientSeen ? (
                                <td>{appointment?.data?.VisitReason}</td>
                              ) : (
                                <td style={{ width: '350px', overflow: 'auto' }}>
                                  {appointment?.data?.VisitReason} {appointment?.data?.notSeenReason === 'Other' ? appointment?.data?.customReason : appointment?.data?.notSeenReason}
                                </td>
                              )}
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center">
                              No appointment available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  )}
                </div>
              </CTabPane>

              <CTabPane visible={activeKey === 2}>
                <div className=" " style={{ height: '60vh', overflow: 'auto' }}>
                  <h5>Note</h5>
                  <div>
                    {tabLoading[2] ? (
                      <TabLoader />
                    ) : patientTreatments.length > 0 ? (
                      <CAccordion>
                        {patientTreatments.map((note, index) => {
                          return (
                            <>
                              <CAccordionItem itemKey={index} className="mb-2 border rounded shadow-sm" style={{ maxWidth: '80vw', overflow: 'auto' }}>
                                <CAccordionHeader>
                                  <CalendarDays size={16} className="me-2" />
                                  <span className="fw-semibold me-3">{new Date(note.date).toLocaleDateString('en-US')}</span>
                                  <span className="text-capitalize">Status: {note.status}</span>
                                </CAccordionHeader>

                                <CAccordionBody style={{ maxWidth: '80vw', overflow: 'hidden' }}>
                                  <PatientInfoFreeType
                                    patientData={{
                                      ...viewPatientDetail,
                                      Status: index == 0 ? 'NewPatient' : 'Follow Up',
                                    }}
                                    patientID={viewPatientDetail.PatientID}
                                    // patientData={viewPatientDetail}
                                    dataCallType="edit"
                                    setDataId={note.id}
                                    noteID={index}
                                    showAllData={false}
                                    showNoteView={true}
                                  />
                                </CAccordionBody>
                              </CAccordionItem>
                            </>
                          )
                        })}
                      </CAccordion>
                    ) : (
                      <div className="text-center">No Notes Available</div>
                    )}
                  </div>
                </div>
              </CTabPane>

              <CTabPane visible={activeKey === 3}>
                <div className="" style={{ height: '60vh', overflow: 'auto' }}>
                  <h5>Super Bill</h5>
                  {tabLoading[3] ? (
                    <TabLoader />
                  ) : superBill && superBill.length > 0 ? (
                    <CAccordion activeItemKey={0} className="  ">
                      {superBill &&
                        superBill?.map((data, index) => {
                          return (
                            <CAccordionItem itemKey={index} className="rounded -2 overflow-hidden border my-2">
                              <CAccordionHeader className="rounded-top" style={{}}>
                                {' '}
                                <CalendarDays size={16} /> <span className="ms-1"> {new Date(data.Data.PDate).toLocaleDateString('en-US')}</span>
                              </CAccordionHeader>
                              <CAccordionBody className="rounded-bottom p-3">
                                <div className="border p-3 rounded">
                                  <div className="container">
                                    <div className="row mb-2">
                                      <div className="col-3">
                                        <strong>Facility Name:</strong>
                                      </div>
                                      <div className="col-8">{data.Data.facilityName}</div>
                                    </div>

                                    <div className="row mb-2">
                                      <div className="col-3">
                                        <strong>Facility Type:</strong>
                                      </div>
                                      <div className="col-8">{data.Data.facilityType}</div>
                                    </div>

                                    <div className="row mb-2">
                                      <div className="col-3">
                                        <strong>Patient Type:</strong>
                                      </div>
                                      <div className="col-8">{data.Data.patientType || 'N/A'}</div>
                                    </div>

                                    <div className="row mb-2">
                                      <div className="col-3">
                                        <strong>Follow Up Time:</strong>
                                      </div>
                                      <div className="col-8">{data.Data.followUpTime}</div>
                                    </div>

                                    <div className="row mb-2">
                                      <div className="col-3">
                                        <strong>Reason:</strong>
                                      </div>
                                      <div className="col-8">{data.Data.reason || 'N/A'}</div>
                                    </div>

                                    <div className="row mb-2">
                                      <div className="col-3">
                                        <strong>CPT Code:</strong>
                                      </div>
                                      <div className="col-8">{data.Data.cptCode}</div>
                                    </div>

                                    <div className="row mb-2">
                                      <div className="col-3">
                                        <strong>ICD Codes:</strong>
                                      </div>
                                      <div className="col-8">
                                        {(data.Data.icdCodes || '').split(', ').filter(Boolean).map((code, index) => (
                                          <span key={index} className="me-2">
                                            {code}
                                          </span>
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </CAccordionBody>
                            </CAccordionItem>
                          )
                        })}
                    </CAccordion>
                  ) : (
                    <p colSpan="4" className="text-center mt-4">
                      No Super Bill Available
                    </p>
                  )}
                </div>
              </CTabPane>

              <CTabPane visible={activeKey === 4}>
                <h5>Orders</h5>
                <div className=" d-flex flex-column  gap-3 px-4" style={{ maxHeight: '60vh', overflow: 'auto' }}>
                  <div className=" " style={{ maxHeight: '70vh', overflow: 'auto' }}>
                    {tabLoading[4] ? (
                      <TabLoader />
                    ) : ordersData.length > 0 ? (
                      <div className=" d-flex flex-column  gap-3 px-1 mt-3" style={{ maxHeight: '70vh', overflow: 'auto' }}>
                        {ordersData.map((data, index) => {
                          const currentOrder = data?.medication
                          const orderFreeTypeSummary = getOrderFreeTypeSummary(viewPatientDetail, currentOrder?.diagnosis)
                          const hasOrderDetails =
                            (currentOrder?.imaging?.imagingTypes?.length || 0) > 0 ||
                            (currentOrder?.lab?.labs?.length || 0) > 0 ||
                            (currentOrder?.medication?.medication?.length || 0) > 0 ||
                            (currentOrder?.miscellaneous?.miscellaneous?.length || 0) > 0
                          return (
                            <div key={index} style={{ background: '#f2f2f2', borderRadius: '10px' }} className="shadow-ex ">
                              <Accordions
                                showChevron={false}
                                showDelete={false}
                                showChain={false}
                                title={
                                  <div className="d-flex align-items-center gap-2 w-100 " style={{ height: '' }}>
                                    <div className="w-100 ">
                                      <p className="fw-semibold   mb-2" style={{ fontSize: '13px' }}>
                                        {formatDate(data.date)} <span className="text-capitalize fw-semibold mx-2">Diagnosis:{data?.medication?.diagnosis}</span>
                                      </p>
                                    </div>
                                  </div>
                                }
                                content={
                                  <div>
                                    <div className="card shadow-sm  ">
                                      <div className="card-body">
                                        {orderFreeTypeSummary ? (
                                          <textarea
                                            aria-label="Order summary"
                                            className="form-control"
                                            style={{ minHeight: '200px', resize: 'vertical' }}
                                            value={orderFreeTypeSummary}
                                            readOnly
                                          />
                                        ) : (
                                          <>
                                        {/* Imaging */}
                                        {currentOrder?.imaging?.imagingTypes?.length > 0 && (
                                          <div className="mb-2">
                                            <p className="text-secondary fw-bold mb-1">Imaging</p>
                                            <ul>
                                              {currentOrder.imaging.imagingTypes.map((imagingItem, iIdx) => (
                                                <li className="p-0 m-0" key={iIdx}>
                                                  {imagingItem?.type}
                                                     {imagingItem?.reason}
                                                        {imagingItem?.code}
                                                  {getScriptFiles(imagingItem?.script).length > 0 ? (
                                                    <span
                                                      className="mb-1 mx-2"
                                                      onClick={() => {
                                                        handleScript(getScriptFiles(imagingItem?.script))
                                                      }}
                                                    >
                                                      <Files size={14} />
                                                    </span>
                                                  ) : (
                                                    ''
                                                  )}
                                                </li>
                                              ))}
                                            </ul>
                                          </div>
                                        )}

                                        {/* Labs */}
                                        {currentOrder?.lab?.labs?.length > 0 && (
                                          <div className="mb-2">
                                            <p className="text-secondary fw-bold mb-1">Labs</p>
                                            <ul>
                                              {currentOrder.lab.labs.map((labItem, lIdx) => (
                                                <li className="p-0 m-0" key={lIdx}>
                                                  {labItem?.lab}
                                                  {labItem?.reason && ` - Reason for ${labItem.lab}: ${labItem.reason}`}
                                                  {labItem?.code && ` - Code for ${labItem.lab}: ${labItem.code}`}
                                                  {getScriptFiles(labItem?.script).length > 0 ? (
                                                    <span
                                                      className="mb-1 mx-2"
                                                      onClick={() => {
                                                        handleScript(getScriptFiles(labItem?.script))
                                                      }}
                                                    >
                                                      <Files size={14} />
                                                    </span>
                                                  ) : (
                                                    ''
                                                  )}
                                                </li>
                                              ))}
                                            </ul>
                                          </div>
                                        )}

                                        {/* Medications */}
                                        {currentOrder?.medication?.medication?.length > 0 && (
                                          <div className="mb-2">
                                            <p className="text-secondary fw-bold mb-1">Medications</p>
                                            <ul>
                                              {currentOrder.medication.medication.map((medItem, mIdx) => (
                                                <li className="p-0 m-0" key={mIdx}>
                                                  {medItem?.name} {medItem?.dosage} {medItem?.route}
                                                  {medItem?.frequency && ` ${medItem.frequency}`}
                                                  {medItem?.reason && ` - ${medItem.reason}`}
                                                  {medItem?.code && ` - ${medItem.code}`}
                                                  {getScriptFiles(medItem?.script).length > 0 ? (
                                                    <span
                                                      className="mb-1 mx-2"
                                                      onClick={() => {
                                                        handleScript(getScriptFiles(medItem?.script))
                                                      }}
                                                    >
                                                      <Files size={14} />
                                                    </span>
                                                  ) : (
                                                    ''
                                                  )}
                                                </li>
                                              ))}
                                            </ul>
                                          </div>
                                        )}

                                        {/* Miscellaneous */}
                                        {currentOrder?.miscellaneous?.miscellaneous?.length > 0 && (
                                          <div className="mb-2">
                                            <p className="text-secondary fw-bold mb-1">Miscellaneous</p>
                                            <ul>
                                              {currentOrder.miscellaneous.miscellaneous.map((miscItem, xIdx) => (
                                                <li className="p-0 m-0" key={xIdx}>
                                                  {typeof miscItem === 'string' ? miscItem : miscItem?.type}
                                                  {getScriptFiles(miscItem?.script).length > 0 ? (
                                                    <span
                                                      className="mb-1 mx-2"
                                                      onClick={() => {
                                                        handleScript(getScriptFiles(miscItem?.script))
                                                      }}
                                                    >
                                                      <Files size={14} />
                                                    </span>
                                                  ) : (
                                                    ''
                                                  )}
                                                </li>
                                              ))}
                                            </ul>
                                          </div>
                                        )}
                                        {!hasOrderDetails && <p className="text-center text-muted mb-0">No order details available</p>}
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                }
                              />
                            </div>
                          )
                        })}
                      </div>
                    ) : (
                      <div className="text-center mt-4">No Orders available</div>
                    )}
                  </div>
                </div>
              </CTabPane>
            </CTabContent>
          </div>

          {showNotePatient && <PatientInfo patientID={viewPatientDetail.PatientID} patientData={viewPatientDetail} dataCallType="edit" setDataId={selectedNote.note.id} noteID={selectedNote.index} showAllData={false} showNoteView={true} />}
        </div>
      }
      <CModal size="md" backdrop="static" visible={showOrderPopUp} onClose={() => setShowOrderPopUp(false)}>
        <CModalHeader>
          <CModalTitle>Order Script</CModalTitle>
        </CModalHeader>
        <CModalBody style={{ height: '300px', overflow: 'auto' }}>
          <div className="d-flex flex-wrap gap-3">
            {file?.map((fileUrl, fileIdx) => {
              const extension = fileUrl.split('.').pop()?.toLowerCase()

              const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)
              const isVideo = ['mp4', 'mov', 'avi', 'mkv', 'webm'].includes(extension)
              const isDocument = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(extension)

              return (
                <div key={fileIdx} className="d-flex flex-column gap-2 align-items-center">
                  <a
                    href={fileUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="shadow rounded p-2 position-relative d-block"
                    style={{
                      width: '100px',
                      height: '100px',
                      overflow: 'hidden',
                      borderRadius: '8px',
                      cursor: 'pointer',

                      textDecoration: 'none',
                    }}
                  >
                    {isVideo ? (
                      <video
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          borderRadius: '8px',
                        }}
                        controls
                      >
                        <source src={fileUrl} type="video/mp4" />
                      </video>
                    ) : isImage ? (
                      <img
                        src={fileUrl}
                        alt="Uploaded"
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          borderRadius: '8px',
                        }}
                      />
                    ) : isDocument ? (
                      <iframe
                        src={fileUrl}
                        title="Document Viewer"
                        style={{
                          width: '100%',
                          height: '100%',
                          border: 'none',
                          borderRadius: '8px',
                          pointerEvents: 'none',
                        }}
                      />
                    ) : (
                      <div
                        className="text-center"
                        style={{
                          color: '#fff',
                          fontSize: '0.75rem',
                          padding: '10px',
                        }}
                      >
                        Unknown File
                      </div>
                    )}
                  </a>
                </div>
              )
            })}
          </div>
        </CModalBody>

        <CModalFooter className="mt-2">
          <CButton onClick={() => setShowOrderPopUp(false)} variant="outline" color="secondary">
            Close
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default PatientAllDetails
